var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 151.462 197.405"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.75 0 0 75.75v121.655h7V78.649L75.75 9.9l68.712 68.712v111.793h-30v-88.622H44.8v95.622h106.662V75.712Zm31.712 190.405H51.8v-81.622h55.666Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.577 112.811h-48v23.931h48Zm-7 16.931h-34v-9.931h34ZM83.077 185.9h20.5v-46.158h-48V185.9zm0-7v-12.58h13.5v12.58Zm13.5-32.161v12.581h-13.5v-12.578Zm-20.5 0v12.581h-13.5v-12.578Zm-13.5 32.161v-12.58h13.5v12.58Z"
}))));
export default SvgLogo;